"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const operators_1 = require("rxjs/operators");
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const forms_1 = require("@angular/forms");
const _4d_mapper_1 = require("4d-mapper");
const vasat_1 = require("vasat");
const app_service_1 = require("../app.service");
const acl_service_1 = require("../acl/acl.service");
const rxjs_1 = require("rxjs");
const common_1 = require("@angular/common");
const core_2 = require("@ngx-translate/core");
const FourDInjector_1 = require("../FourDInjector");
const _ = require('underscore');
const M = require('moment');
class AppDialog {
    constructor(dialogRef, data, fourD, permissions, service, locale, dialog) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.fourD = fourD;
        this.permissions = permissions;
        this.service = service;
        this.locale = locale;
        this.dialog = dialog;
        this.nameControl = new forms_1.FormControl('');
        this.inputControl = new forms_1.FormControl('');
        this.inputControlURL = new forms_1.FormControl('');
        this.inputControlMsg = new forms_1.FormControl('');
        this.emailControl = new forms_1.FormControl('');
        this.emailControlMsg = new forms_1.FormControl('');
        this.type_Dataset = _4d_mapper_1.Dataset;
        this.type_Transform = _4d_mapper_1.Transform;
        this.isOver = false;
        // if we need to deal with permissions
        this.permission_options = null;
        // folder attributes
        this.folder_properties = null;
        // have we got options?
        this.haveOptions = false;
        // various options
        this.optionExpireDays = 7;
        this.optionEmailShareLink = false;
        this.translate = FourDInjector_1.FourDInjector.injector.get(core_2.TranslateService);
        this.roles = [];
        // console.log ( 'app-dialog.ts :: constructor :: begin', this.data, this.inputControl );
        if (this.data.isExternalURL) {
            const reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
            this.inputControl.setValidators([forms_1.Validators.minLength(1), forms_1.Validators.maxLength(300)
                //, Validators.pattern(reg)
            ]);
        }
        else {
            this.inputControl.setValidators([forms_1.Validators.required, forms_1.Validators.minLength(2)]);
        }
        this.meta = data.meta || {};
        // console.log ( "app-dialog.ts :: constructor :: incoming input data", data.input );
        // incoming inputs?
        if (data.input) {
            if (typeof data.input.name !== 'undefined') {
                // incoming name field
                this.nameControl.setValue(data.input.name);
            }
            // input is an object, with values
            if (typeof data.input.value !== 'undefined') {
                this.inputControl.setValue(data.input.value);
                this.passedValue = data.input.value;
                // console.log ('app-dialog.ts :: constructor :: setting object "value"', data.input );
            }
            else {
                // console.error ( '!!!', typeof data.input );
                if (typeof data.input !== 'object') {
                    this.inputControl.setValue(data.input);
                    this.passedValue = data.input;
                    // console.log ('app-dialog.ts :: constructor :: setting value', data.input );
                }
                else {
                    this.inputControl.setValue(null);
                }
            }
            // input is a set of permissions (so, maybe we're sharing a link or something)
            if (typeof data.input.permissions !== 'undefined') {
                this.permission_options = data.input.permissions;
            }
            if (typeof data.input.folder_properties !== 'undefined') {
                this.folder_properties = data.input.folder_properties;
            }
        }
        this.fourD.V.searchByObject(vasat_1.Role).equals("desc", "4D Public|4D Mapper").queryObservable().subscribe(s => {
            this.roles = s.items;
        });
        if (this.data.mode == 'user') {
            this.users = this.fourD.V.searchByObject(vasat_1.User);
            this.users.queryObservable().subscribe(s => {
                this.results = s;
            });
        }
        // console.log ( 'app-dialog.ts :: constructor :: end', this.data, this.inputControl );
    }
    onClick(res) {
        // console.log ( 'app-dialog onClick', res, this.data);
        // clicked OK for choosing a folder
        if (this.data.mode == 'folder') {
            this.dialogRef.close(this.selectedFolder);
        }
        // clicked OK for choosing file(s)
        else if (this.data.mode == 'file' || this.data.mode == 'file_all') {
            if (this.data.input) {
                if (!res) {
                    /*var okMSg, errMsg
                    this.translate.get(['PROJECT.DELETE.SUCCESS', 'PROJECT.DELETE.ERROR']).map(params => {
                      okMSg = params['PROJECT.DELETE.SUCCESS']
                      errMsg = params['PROJECT.DELETE.ERROR']
                    }).flatMap(e => {*/
                    let dialogRef = this.dialog.open(AppDialog, {
                        width: '350px',
                        data: {
                            title: 'PROJECT.DELETE.TITLE',
                            text: 'PROJECT.DELETE.MSG',
                            posBtn: 'GENERIC.YES',
                            negBtn: 'GENERIC.NO',
                            meta: { name: this.data.meta.name }
                        }
                    });
                    dialogRef.afterClosed().subscribe(
                    // flatMap(
                    s => {
                        if (s) {
                            return this.data.meta.destroyObservable().subscribe(s => {
                                this.data.meta['nuked'] = true;
                                this.dialogRef.close({ project: this.data.meta });
                            }, e => {
                                this.data.meta['nuked'] = 'Error';
                                this.dialogRef.close({ project: this.data.meta });
                            });
                        }
                    }
                    /*}
                    )*/
                    );
                    /*}).subscribe(
                      s => {
                        if (s) {
                          // this.openSnackBarInfo(okMSg, null)
                          this.data.meta['nuked'] = true
                          this.dialogRef.close({project: this.data.meta})
                        }
                      },
                      e => {this.data.meta['nuked'] = 'Error';
                        this.dialogRef.close({project : this.data.meta})}
                    );*/
                    /*this.data.meta.destroyObservable().subscribe(
                      s => {
                        this.data.meta['nuked'] = true
                        this.dialogRef.close({project: this.data.meta})
                      },
                      e => {this.data.meta['nuked'] = 'Error';
                              this.dialogRef.close({project : this.data.meta})}
                    )*/
                }
                else {
                    if (this.inputControl.value !== this.passedValue) {
                        this.data.meta.project.name = this.inputControl.value;
                        this.data.meta.project.saveObservable().subscribe(s => {
                            this.data.project.meta['saved'] = true;
                            this.dialogRef.close({
                                selectedFiles: this.selectedFiles,
                                project: this.data.meta.project,
                                selectedFolder: this.selectedFolder
                            });
                        }, e => {
                            this.data.project.meta['saved'] = 'Error';
                            this.dialogRef.close({
                                selectedFiles: this.selectedFiles,
                                project: this.data.meta.project,
                                selectedFolder: this.selectedFolder
                            });
                        });
                    }
                    else {
                        this.dialogRef.close({
                            selectedFiles: this.selectedFiles,
                            project: this.data.meta,
                            selectedFolder: this.selectedFolder
                        });
                    }
                }
            }
            else {
                this.dialogRef.close({
                    selectedFiles: this.selectedFiles,
                    selectedFolder: this.selectedFolder
                });
            }
        }
        // clicked OK for choosing a user
        else if (this.data.mode == 'user') {
            this.dialogRef.close(this.selectedUser);
        }
        // clicked OK with permissions and options (a share link)
        else if (res && this.permission_options) {
            if (this.nameControl.valid) {
                this.dialogRef.close({
                    email: this.emailControl.value,
                    name: this.nameControl.value,
                    message: this.emailControlMsg.value,
                    permissions: this.permission_options,
                    roles: this.roles.filter(r => r['use']),
                    expire: this.haveOptions ? this.optionExpireDays : false
                });
            }
        }
        // clicked OK, with folder attributes
        else if (this.folder_properties) {
            this.dialogRef.close({
                folder_properties: this.folder_properties
            });
        }
        // clicked OK, check for data input
        else if (this.data.input && this.data.input.copy) {
            this.copyLink(res, () => this.dialogRef.close(res));
            // all else
        }
        else {
            this.dialogRef.close(res);
        }
    }
    updateQuery(f) {
        const mainDiv = document.getElementById('mainDIV');
        mainDiv.scrollTop = 0;
        if (this.data.filter && this.data.filter !== 'Dataset') {
            this.query = {
                op: 'and',
                items: [
                    {
                        col: 'folder', op: '=', val: f.id
                    },
                    {
                        col: 'transformType',
                        op: 'in',
                        ids: this.fourD.transformTypes.filter(t => {
                            if (this.data.filter == 'photo-dzi') {
                                return t.uid == this.data.filter || t.uid == 'thumb';
                            }
                            else
                                return t.uid == this.data.filter;
                        }).map(t => t.id)
                    }
                ]
            };
        }
        else {
            this.query = {
                col: 'folder', op: '=', val: f.id
            };
        }
    }
    setVal(f) {
        this.selectedFolder = f;
        // once folder is selected, then unselect all selected files
        this.selectedFiles = undefined;
        /* const mainDiv = document.getElementById('mainDIV');
         mainDiv.scrollTop = 0;*/
    }
    copyLink(text, callback) {
        var event = (e) => {
            e.clipboardData.setData('text/plain', text);
            e.preventDefault();
            document.removeEventListener('copy', event);
            if (callback)
                callback();
        };
        document.addEventListener('copy', event);
        document.execCommand('copy');
    }
    dragOver(e) {
        e.preventDefault();
        this.isOver = true;
        return false;
    }
    dragLeave(e) {
        e.preventDefault();
        this.isOver = false;
        return false;
    }
    dropFiles(e) {
        if (e.stopPropagation)
            e.stopPropagation();
        e.preventDefault();
        var filez = e.dataTransfer.files;
        var l = filez.length;
        var grp = _.groupBy(filez, (obj, i) => '_' + Math.floor(i / 10));
        this.fourD.V.searchByObject(_4d_mapper_1.Folder).equals('name', 'uploaded from ' + this.data.meta.name).queryObservable().subscribe(value => {
            if (value && value.items.length > 0) {
                var deQueue = () => {
                    var a = Object.keys(grp);
                    if (a.length) {
                        var key = a[0];
                        var items = grp[key];
                        this._sendBatch(items, value.items[0]).subscribe(s => {
                            delete grp[key];
                            deQueue();
                        });
                    }
                };
                deQueue();
                this.isOver = false;
                return false;
            }
            else {
                var folder = new _4d_mapper_1.Folder(this.fourD.V);
                /*folder.name = this.data.meta.name + '_' +  (formatDate(new Date() , 'yyyy-MM-dd HH:mm:ss', this.locale));*/
                folder.name = 'uploaded from ' + this.data.meta.name;
                folder.saveObservable().subscribe(() => {
                    var deQueue = () => {
                        var a = Object.keys(grp);
                        if (a.length) {
                            var key = a[0];
                            var items = grp[key];
                            this._sendBatch(items, folder).subscribe(s => {
                                delete grp[key];
                                deQueue();
                            });
                        }
                    };
                    deQueue();
                    this.isOver = false;
                    return false;
                });
            }
        });
    }
    uploadFiles(e) {
        var filez = e.srcElement.files;
        var l = filez.length;
        var grp = _.groupBy(filez, (obj, i) => '_' + Math.floor(i / 10));
        var folder = new _4d_mapper_1.Folder(this.fourD.V);
        folder.name = this.data.meta.name + '_' + (common_1.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss', this.locale));
        folder.saveObservable().subscribe(() => {
            var deQueue = () => {
                var a = Object.keys(grp);
                if (a.length) {
                    var key = a[0];
                    var items = grp[key];
                    this._sendBatch(items, folder).subscribe(s => {
                        delete grp[key];
                        deQueue();
                    });
                }
            };
            deQueue();
            return false;
        });
    }
    _sendBatch(files, folder) {
        var filesObs = files.map(v => {
            var name = v.name;
            var blank = new _4d_mapper_1.Dataset(this.service.V).set({
                name: name,
                folder: folder,
                incomplete_offset: 0,
                incomplete_seq: 0,
                incomplete_total: length,
                incomplete: true
            });
            return blank.saveObservable().pipe(operators_1.map(ds => {
                return {
                    dataset: ds,
                    file: v,
                    valid: true
                };
            }));
        });
        return rxjs_1.forkJoin(filesObs).pipe(operators_1.map(res => {
            res.forEach(s => {
                if (s.valid) {
                    console.log(s.dataset.id);
                    this.progressFileId = s.dataset.id;
                    this.fourD.uploadFile(s.dataset, s.file, 'data', 19000000);
                }
            });
            return res;
        }));
    }
    ngOnDestroy() {
        this.selectedFolder = undefined;
    }
    openURL() {
        let url = '';
        if (!/^http[s]?:\/\//.test(this.inputControl.value)) {
            url += 'http://';
        }
        url += this.inputControl.value;
        window.open(url, '_blank');
    }
}
exports.AppDialog = AppDialog;
